// src/constants/likertScales.js
export const likertScaleTypes = [
  {
    id: "AGREEMENT",
    label: "Agreement Scale",
    options: [
      "Strongly Agree",
      "Agree",
      "Neutral",
      "Disagree",
      "Strongly Disagree",
    ],
  },
  {
    id: "FREQUENCY",
    label: "Frequency Scale",
    options: ["Always", "Often", "Sometimes", "Rarely", "Never"],
  },
  {
    id: "SATISFACTION",
    label: "Satisfaction Scale",
    options: [
      "Very Satisfied",
      "Satisfied",
      "Neutral",
      "Dissatisfied",
      "Very Dissatisfied",
    ],
  },
  {
    id: "IMPORTANCE",
    label: "Importance Scale",
    options: [
      "Very Important",
      "Important",
      "Neutral",
      "Unimportant",
      "Very Unimportant",
    ],
  },
  {
    id: "LIKELIHOOD",
    label: "Likelihood Scale",
    options: ["Very Likely", "Likely", "Neutral", "Unlikely", "Very Unlikely"],
  },
  {
    id: "QUALITY",
    label: "Quality Scale",
    options: ["Excellent", "Good", "Average", "Poor", "Very Poor"],
  },
  {
    id: "CONFIDENCE",
    label: "Confidence Scale",
    options: [
      "Very Confident",
      "Confident",
      "Neutral",
      "Not Confident",
      "Not at all Confident",
    ],
  },
  {
    id: "SENTIMENT",
    label: "Sentiment Scale",
    options: [
      "Very Positive",
      "Somewhat Positive",
      "Neutral",
      "Somewhat Negative",
      "Very Negative",
    ],
  },
  {
    id: "CUSTOM",
    label: "Custom Scale",
    options: [], // Will be populated dynamically
  },
];
